import React from 'react'
import { KPIList } from './list/page'

export const KPIPage = (): JSX.Element => {
  return <KPIList></KPIList>
}
